var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 253,
    viewBox: "0 0 775 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 154.737L32.1219 172.683L105.588 130.062L73.3426 112.116L1 154.737Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17578 198.586L32.2977 216.532L105.764 173.911L73.5184 155.971L1.17578 198.586Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 172.683V216.531",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.996 129.66V173.514",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 154.424V199.411",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1211 172.281L63.2482 190.227L136.709 147.606L104.464 129.66L32.1211 172.281Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 216.136L63.424 234.076L136.885 191.461L104.64 173.515L32.2969 216.136Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 190.227V234.075",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.117 147.204V191.058",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1211 171.973V216.955",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 110.888L32.1219 128.829L105.588 86.2135L73.3426 68.2676L1 110.888Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17578 154.737L32.2977 172.683L105.764 130.062L73.5184 112.116L1.17578 154.737Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 128.83V172.684",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.996 85.8115V129.66",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1 110.575V155.563",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 128.432L63.424 146.378L136.885 103.757L104.64 85.8115L32.2969 128.432Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4727 172.281L63.5946 190.227L137.06 147.606L104.815 129.66L32.4727 172.281Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4258 146.378V190.227",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.293 103.355V147.204",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 128.119V173.107",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.457 190.205L94.5842 208.151L168.045 165.53L135.8 147.584L63.457 190.205Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6328 234.053L94.7599 251.999L168.221 209.379L135.975 191.433L63.6328 234.053Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5859 208.15V251.999",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.453 165.128V208.977",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.457 189.892V234.879",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6289 146.351L94.756 164.297L168.217 121.676L135.972 103.73L63.6289 146.351Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8047 190.206L94.9318 208.147L168.392 165.531L136.147 147.585L63.8047 190.206Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7578 164.297V208.151",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.625 121.279V165.128",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6289 146.043V191.031",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 67.1863L32.1219 85.1322L105.588 42.5113L73.3426 24.5654L1 67.1863Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17578 111.036L32.2977 128.981L105.764 86.3606L73.5184 68.4199L1.17578 111.036Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 85.1318V128.98",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.996 42.1094V85.9632",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66.873V111.861",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 84.7293L63.424 102.675L136.885 60.0543L104.64 42.1084L32.2969 84.7293Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4727 128.579L63.5946 146.524L137.06 103.909L104.815 85.9629L32.4727 128.579Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4258 102.675V146.523",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136.293 59.6523V103.506",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 84.416V129.404",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6289 102.655L94.756 120.596L168.217 77.9801L135.972 60.0342L63.6289 102.655Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8047 146.504L94.9318 164.45L168.392 121.829L136.147 103.883L63.8047 146.504Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7578 120.597V164.451",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M167.625 77.5781V121.427",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6289 102.341V147.328",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 154.737L515.643 172.683L589.103 130.062L556.858 112.116L484.516 154.737Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M484.691 198.586L515.813 216.532L589.279 173.911L557.034 155.971L484.691 198.586Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M515.645 172.683V216.531",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M588.512 129.66V173.514",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 154.424V199.411",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M515.641 172.281L546.763 190.227L620.223 147.606L587.978 129.66L515.641 172.281Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M515.812 216.136L546.94 234.076L620.4 191.461L588.155 173.515L515.812 216.136Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M546.766 190.227V234.075",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M619.633 147.204V191.058",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M515.641 171.973V216.955",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 110.887L515.643 128.828L589.103 86.2125L556.858 68.2666L484.516 110.887Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M484.691 154.736L515.813 172.682L589.279 130.061L557.034 112.115L484.691 154.736Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M515.645 128.829V172.683",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M588.512 85.8105V129.659",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 110.574V155.562",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M515.816 128.431L546.944 146.377L620.404 103.756L588.159 85.8105L515.816 128.431Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M515.992 172.28L547.119 190.226L620.58 147.605L588.335 129.659L515.992 172.28Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M546.945 146.377V190.226",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M619.812 103.354V147.203",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M515.816 128.117V173.105",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M730.537 44.3338L699.415 62.2797L625.949 19.6588L658.194 1.71289L730.537 44.3338Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M730.361 88.1824L699.239 106.128L625.773 63.5074L658.019 45.5615L730.361 88.1824Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M699.414 62.2793V106.128",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M626.543 19.2568V63.1107",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M730.539 44.0205V89.008",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M667.625 131.885L698.747 149.83L772.213 107.21L739.968 89.2637L667.625 131.885Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M667.801 175.733L698.923 193.679L772.389 151.058L740.143 133.112L667.801 175.733Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M698.75 149.83V193.679",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M771.621 106.808V150.661",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M667.625 131.571V176.559",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 67.1863L515.643 85.1322L589.103 42.5113L556.858 24.5654L484.516 67.1863Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M484.691 111.036L515.813 128.981L589.279 86.3606L557.034 68.4199L484.691 111.036Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M515.645 85.1318V128.98",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M588.512 42.1094V85.9632",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M484.516 66.873V111.861",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M553.289 62.8032L584.411 80.749L657.877 38.1282L625.632 20.1875L553.289 62.8032Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M553.465 106.658L584.587 124.604L658.053 81.983L625.807 64.0371L553.465 106.658Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M584.414 80.75V124.604",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M657.285 37.7314V81.5801",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M553.289 62.4941V107.482",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M667.625 88.1824L698.747 106.128L772.213 63.5074L739.968 45.5615L667.625 88.1824Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M667.801 132.037L698.923 149.978L772.389 107.362L740.143 89.416L667.801 132.037Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M698.75 106.128V149.977",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M771.621 63.1055V106.959",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M667.625 87.874V132.856",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 154.737L259.098 172.683L332.564 130.062L300.319 112.116L227.977 154.737Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M228.152 198.586L259.274 216.532L332.74 173.911L300.495 155.971L228.152 198.586Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259.102 172.683V216.531",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M331.969 129.66V173.514",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 154.424V199.411",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259.09 172.281L290.217 190.227L363.678 147.606L331.433 129.66L259.09 172.281Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M259.266 216.136L290.388 234.076L363.853 191.461L331.608 173.515L259.266 216.136Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M290.219 190.227V234.075",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M363.086 147.204V191.058",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M259.09 171.973V216.955",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 110.887L259.098 128.828L332.564 86.2125L300.319 68.2666L227.977 110.887Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M228.152 154.736L259.274 172.682L332.74 130.061L300.495 112.115L228.152 154.736Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M259.102 128.829V172.683",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M331.969 85.8105V129.659",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 110.574V155.562",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M290.785 110.214L321.912 128.16L395.373 85.5387L363.128 67.5928L290.785 110.214Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M290.961 154.062L322.083 172.008L395.549 129.387L363.304 111.441L290.961 154.062Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M321.914 128.159V172.008",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M394.781 85.1367V128.991",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M290.785 109.9V154.888",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M290.43 190.205L321.557 208.151L395.018 165.53L362.772 147.584L290.43 190.205Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M290.605 234.053L321.733 251.999L395.193 209.379L362.948 191.433L290.605 234.053Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M321.559 208.15V251.999",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M394.426 165.128V208.977",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M290.43 189.892V234.879",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M322.117 128.135L353.244 146.08L426.705 103.46L394.46 85.5137L322.117 128.135Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M322.293 171.989L353.42 189.93L426.881 147.314L394.636 129.368L322.293 171.989Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M353.246 146.08V189.934",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M426.113 103.062V146.911",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M322.117 127.826V172.814",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 67.1863L259.098 85.1322L332.564 42.5113L300.319 24.5654L227.977 67.1863Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M228.152 111.036L259.274 128.981L332.74 86.3606L300.495 68.4199L228.152 111.036Z",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.102 85.1318V128.98",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M331.969 42.1094V85.9632",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M227.977 66.873V111.861",
    stroke: "white",
    strokeWidth: 0.976968,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M290.785 66.5125L321.912 84.4584L395.373 41.8375L363.128 23.8916L290.785 66.5125Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M290.961 110.362L322.083 128.308L395.549 85.692L363.304 67.7461L290.961 110.362Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M321.914 84.458V128.307",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M394.781 41.4355V85.2894",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M290.785 66.1992V111.187",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M322.117 84.4363L353.244 102.377L426.705 59.7614L394.46 41.8154L322.117 84.4363Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M322.293 128.285L353.42 146.231L426.881 103.61L394.636 85.6641L322.293 128.285Z",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M353.246 102.378V146.232",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M426.113 59.3594V103.208",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M322.117 84.123V129.111",
    stroke: "#26483E",
    strokeWidth: 1.69794,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.89a8cd41764cd5824fb91b106b187036.svg";
export { ForwardRef as ReactComponent };